import { Box, Paper, Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import EventForm from 'src/components/EventForm';
import EventGroupForm from 'src/components/EventGroupForm';
import TabPanel from '../components/TabPanel';
import ScrollableLayout from '../layouts/ScrollableLayout';
import { CREATE_EVENT_GROUP_ROUTE, CREATE_EVENT_ROUTE } from '../constants';
import { usePermissions } from 'src/hooks/usePermissions';
import PermissionDenied from 'src/components/PermissionDenied';

export default function CreateScreen() {
    const { canEditEvents, isLoading: permissionsLoading } = usePermissions();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const groupId = searchParams.get('groupId') || undefined;

    // Derive tab directly from URL

    if (!permissionsLoading && !canEditEvents) {
        return <PermissionDenied requiredPermission="Create Events" />;
    }

    const tabValue = location.pathname === CREATE_EVENT_GROUP_ROUTE ? 1 : 0;

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        // Navigate to update URL, preserving search params
        const newPath = newValue === 1 ? CREATE_EVENT_GROUP_ROUTE : CREATE_EVENT_ROUTE;
        const search = searchParams.toString();
        navigate(search ? `${newPath}?${search}` : newPath, { replace: true });
    };

    return (
        <ScrollableLayout>
            <Paper
                sx={{
                    minWidth: '300px',
                    width: '100%',
                    maxWidth: '400px',
                    margin: '20px auto',
                    boxShadow: 3,
                }}
                elevation={4}
            >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="fullWidth"
                        sx={{
                            '& .MuiTab-root': {
                                fontSize: '1rem',
                                fontWeight: 500,
                                textTransform: 'none',
                                minHeight: 56,
                            },
                            '& .Mui-selected': {
                                fontWeight: 600,
                            },
                        }}
                    >
                        <Tab label="Create Event" id="create-tab-0" aria-controls="create-tabpanel-0" />
                        <Tab label="Create Group" id="create-tab-1" aria-controls="create-tabpanel-1" />
                    </Tabs>
                </Box>

                <TabPanel value={tabValue} index={0} idPrefix="create" contentSx={{}}>
                    <EventForm inTab groupId={groupId} />
                </TabPanel>

                <TabPanel value={tabValue} index={1} idPrefix="create" contentSx={{}}>
                    <EventGroupForm inTab />
                </TabPanel>
            </Paper>
        </ScrollableLayout>
    );
}
